import * as Msal from 'msal';
import decoder from 'jwt-decode';
import baseApi from './common/api/base';

//This is a modification of @kdpw/msal-b2c-react

const logger = new Msal.Logger(loggerCallback, {
    level: Msal.LogLevel.Warning
});

const state = {
    noScopes: false,
    idToken: null,
    accessToken: null,
    firstLogin: false,
    firstLoginRedirect: false
}

let appConfig = {
    // optional, will default to 'https://login.microsoftonline.com/tfp/'
    instance: null,
    // your B2C tenant
    tenant: null,
    // the policy to use to sign in, can also be a sign up or sign in policy
    signInPolicy: null,
    // the policy to use for password reset
    resetPolicy: null,
    // the the B2C application you want to authenticate with
    applicationId: null,
    // where MSAL will store state - localStorage or sessionStorage
    cacheLocation: null,
    // optional, the scopes you want included in the access token
    scopes: [],
    // optional, the redirect URI - if not specified MSAL will pick up the location from window.href
    redirectUri: null,
    // optional, the URI to redirect to after logout
    postLogoutRedirectUri: null,
    // optional, default to true, set to false if you change instance
    validateAuthority: null,
    // optional, default to true
    storeAuthStateInCookie: true
};

function loggerCallback(logLevel, message, piiLoggingEnabled) {
    console.log(message);
}

function authCallback(errorDesc, token, error, tokenType) {
    if (errorDesc) {
        const forgotPasswordErrorCode = 'AADB2C90118';
        const userForgotPassword = errorDesc.indexOf(forgotPasswordErrorCode) > -1;

        const userCancelledErrorCode = 'AADB2C90091';
        const userCancelled = errorDesc.indexOf(userCancelledErrorCode) > -1;

        if (userForgotPassword) {
            redirectToPasswordReset();
        } else if (userCancelled) {
            authentication.signOut();
        } else {
            console.log(error + ':' + errorDesc);
        }
    }
}

function redirectToPasswordReset() {
    const localMsalApp = window.msal;
    const instance = appConfig.instance ? appConfig.instance : 'https://login.microsoftonline.com/tfp/';
    const authority = `${instance}${appConfig.tenant}/${appConfig.resetPolicy}`;
    localMsalApp.authority = authority;
    localMsalApp.loginRedirect();
}

function isLoggedIn() {
    return !!window.msal.getUser(appConfig.scopes);
}

function loginAndAcquireToken(successCallback) {
    const localMsalApp = window.msal;
    let user = localMsalApp.getUser(appConfig.scopes);

    if (!user) {
        // user is not logged in
        if (state.noScopes) {
            // no need of access token, just redirect to login page
            localMsalApp.loginRedirect(appConfig.scopes);
        } else {
            // try to get token from SSO session
            localMsalApp.acquireTokenSilent(appConfig.scopes, null, null, "&login_hint&domain_hint=organizations")
            .then(accessToken => {
                state.accessToken = accessToken;
                user = localMsalApp.getUser(appConfig.scopes);
                state.idToken = user.idToken;

                if (successCallback) {
                    successCallback();
                }
            }, error => {
                if (error) {
                    // This handles error "AADB2C90077: User does not have an existing session and request prompt parameter has a value of 'None'."
                    // (AKA user interaction is required) by redirecting the user to login
                    localMsalApp.loginRedirect(appConfig.scopes);
                }
            });
        }
    } else {
        // the user is already logged in
        state.idToken = user.idToken;

        const userIsSigningInAfterPasswordReset = localMsalApp.authority &&
            state.idToken.tfp &&
            !localMsalApp.authority.toLowerCase().includes(state.idToken.tfp.toLowerCase()) &&
            localMsalApp.authority.includes(appConfig.signInPolicy.toLowerCase());

        if (userIsSigningInAfterPasswordReset) {
            const storedAccessToken = sessionStorage.getItem(state.idToken);
            state.accessToken = storedAccessToken;
            sessionStorage.removeItem(state.idToken);

            const instance = appConfig.instance ? appConfig.instance : 'https://login.microsoftonline.com/tfp/';
            const authority = `${instance}${appConfig.tenant}/${appConfig.signInPolicy}`;

            baseApi.User.UnsetUpdateForcePasswordChangeNextSignIn()
              .then(res => {
                  
                    state.firstLoginRedirect = false;
                    const isLogout = !state.firstLoginRedirect;
                    // This logout is a workaround for https://statusqatest.atlassian.net/browse/MIMI-91
                    if (isLogout) {
                        localMsalApp.logout();
                    }
                    localMsalApp.authority = authority;
                    state.firstLogin = false;
                    state.firstLoginRedirect = false;
                  // Added 1 second delay so that the setting in B2C has time to be set before redirecting.  
                  // Without this, it keeps asking for verification code.
                  setTimeout(function () {
                      localMsalApp.loginRedirect(appConfig.scopes);
                  }, 2000);
                }, err => {
                    localMsalApp.authority = authority;
                    localMsalApp.loginRedirect(appConfig.scopes);
                });
        } else {
            if (state.noScopes) {
                if (successCallback) {
                    successCallback();
                }
            } else {
                // get access token
                localMsalApp.acquireTokenSilent(appConfig.scopes).then(accessToken => {
                    state.accessToken = accessToken;
                    if (!state.firstLoginRedirect){
                        const decoded = decoder(accessToken);
                        for (let prop in decoded) {
                            if (prop.match('ForcePasswordChangeNextSignIn')) {
                                state.firstLogin = decoded[prop];
                            }
                        }
                    }

                    if (state.firstLogin && !state.firstLoginRedirect) {
                        if (typeof (Storage) !== "undefined") {
                            sessionStorage.setItem(state.idToken, accessToken);
                        }
                        state.firstLoginRedirect = true;
                        redirectToPasswordReset();
                    } else {
                        state.firstLoginRedirect = false;
                        if (successCallback) {
                            successCallback();
                        }
                    }
                },
                error => {
                    if (error) {
                        localMsalApp.acquireTokenRedirect(appConfig.scopes);
                    }
                });
            }
        }
    }
}

const authentication = {
  initialize: (config) => {
    appConfig = config;
    const instance = config.instance ? config.instance : 'https://login.microsoftonline.com/tfp/';
    const authority = `${instance}${config.tenant}/${config.signInPolicy}`;
    const validateAuthority = (config.validateAuthority != null) ? config.validateAuthority : true;
    const scopes = config.scopes;
    if (!scopes || scopes.length === 0) {
      console.log('To obtain access tokens you must specify one or more scopes. See https://docs.microsoft.com/en-us/azure/active-directory-b2c/active-directory-b2c-access-tokens');
      state.noScopes = true;
    }
    state.scopes = scopes;

    const userAgentApp = new Msal.UserAgentApplication(
      config.applicationId,
      authority,
      authCallback,
      {
        logger: logger,
        cacheLocation: config.cacheLocation,
        storeAuthStateInCookie: config.storeAuthStateInCookie,
        postLogoutRedirectUri: config.postLogoutRedirectUri,
        redirectUri: config.redirectUri,
        validateAuthority: validateAuthority,
        navigateToLoginRequestUrl: false
      }
    );
  },
  //required: (WrappedComponent, LoadingComponent) => {
  //  const [signedIn, setSignedIn] = useState(false);

  //  useEffect(() => {
  //// eslint-disable-next-line react-hooks/exhaustive-deps
  //    loginAndAcquireToken(() => {
  //      setSignedIn(true);
  //    });
  //  }, [])
  //  if (signedIn) {
  //    return (<WrappedComponent />);
  //  }
  //  return (<LoadingComponent />);

       
  //  },
    signOut: () => {
        window.msal.logout();
    },
    getAccessToken: () => {
        return state.accessToken;
    },
    getTokenExpirationTime: () => {
        if (!state.accessToken) return null;
        const decoded = decoder(state.accessToken);

        const utcSeconds = decoded.exp;
        const d = new Date(0); // 0 is the key, which sets the date to the epoch
        d.setUTCSeconds(utcSeconds);

        return d;
    },
    getCurrentUser: () => {
        const decoded = decoder(authentication.getAccessToken());
        let decodedForcePasswordChangeNextSignIn = false;
        for (let prop in decoded) {
            if (prop.match('ForcePasswordChangeNextSignIn')) {
                decodedForcePasswordChangeNextSignIn = decoded[prop];
            }
        }

        return {
            name: decoded.name,
            firstName: decoded.given_name,
            lastName: decoded.family_name,
            emails: decoded.emails,
            forcePasswordChangeNextSignIn: decodedForcePasswordChangeNextSignIn
        }
    },
    updateToken: () => {
        loginAndAcquireToken();
    },
    logIn: (successCallback) => {
        loginAndAcquireToken(successCallback);
    },
    signedIn: () => {
        return isLoggedIn();
    }
}

export default authentication;